module.exports = __webpack_public_path__ + "theme/assets/img/783c88970f3288636340a1b1ae9b73b7.jpg";